const state = {
  acumulados: {},
  gerais: {},
  geracao: {},
  geracaoCSV: {},
  eficiencia: {},
  eficienciaCSV: {},
  material: {},
  setedias: {}
}

const mutations = {
  fillDataAcumulados (state, res) {
    // state.acumulados = res.data.grafico sd2018
    state.acumulados = res.data
  },
  fillDataGerais (state, res) {
    // state.gerais = res.data.grafico sd20218
    state.gerais = res.data
  },
  fillDataGeracao (state, res) {
    // state.gerais = res.data.grafico sd20218
    state.geracao = res.data.grafico
    state.geracaoCSV = res.data.export
  },
  fillDataEficiencia (state, res) {
    // state.gerais = res.data.grafico sd20218
    state.eficiencia = res.data.grafico
    state.eficienciaCSV = res.data.export
  },
  fillDataMaterial (state, res) {
    // state.material = res.data.grafico sd20218
    state.material = res.data
  },
  fillDataSeteDias (state, res) {
    // state.material = res.data.grafico sd20218

    state.setedias = res.data
  }
}

const actions = {
  createGraficoGeracao(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    console.log(data)
    return window.axios.post('/relatorios/geracao', data).then((res) => {
      context.commit('fillDataGeracao', res)
      return res
    })
  },
  createGraficoEficiencia(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    console.log(data)
    return window.axios.post('/relatorios/eficiencia', data).then((res) => {
      context.commit('fillDataEficiencia', res)
      return res
    })
  },
  createGraficoGerais(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/relatorios', data).then((res) => {
      context.commit('fillDataGerais', res)
      return res
    })
  },
  createGraficoSeteDias(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/relatorios/setedias', data).then((res) => {
      context.commit('fillDataSeteDias', res)
      return res
    })
  },
  createGraficoMateriais(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/relatorios', data).then((res) => {
      context.commit('fillDataMaterial', res)
      return res
    })
  },
  createGraficoAcumulados(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/relatorios/dias', data).then((res) => {
      context.commit('fillDataAcumulados', res)
      return res
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Relatorios.js